module.exports = __webpack_public_path__ + "static/media/CharacterFeature_Apple.38cf9561.png";